import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-online-number',
  standalone: true,
  templateUrl: './online-number.component.html',
  styleUrls: ['./online-number.component.scss'],
})
export class OnlineNumberComponent implements OnInit {
  @Input() value = 0;
  displayValue = 0;
  animate = false;

  ngOnInit(): void {}

  /**
   * 根據給定的玩家數量計算顯示數量，並賦值給displayValue
   *
   * 規則：
   * - 如果輸入值為0，有65%概率返回0(不顯示)，35%概率返回1-10的隨機數
   * - 1-20 玩家：應用5倍
   * - 20-50 玩家：應用4倍
   * - 50-100 玩家：應用3倍
   * - 100-200 玩家：應用2倍
   * - >200 玩家：應用1.5倍(向上取整)
   *
   * @param item 輸入的玩家數量
   */
  calculateOnlinePlayersDisplay(item: number): void {
    // console.log('11111', item);
    // // 特殊處理：如果輸入為0
    // if (item === 0) {
    //   // 65% 概率設置為0 (不顯示)
    //   if (Math.random() <= 0.65) {
    //     this.displayValue = 0;
    //     return;
    //   }
    //   // 35% 概率設置為1-10的隨機數
    //   this.displayValue = Math.floor(Math.random() * 10) + 1;
    //   return;
    // }

    // 根據不同範圍計算倍數
    let multiplier: number;

    if (item <= 20) {
      multiplier = 5; // 1-20 玩家：5倍
    } else if (item <= 50) {
      multiplier = 4; // 20-50 玩家：4倍
    } else if (item <= 100) {
      multiplier = 3; // 50-100 玩家：3倍
    } else if (item <= 200) {
      multiplier = 2; // 100-200 玩家：2倍
    } else {
      multiplier = 1.5; // >200 玩家：1.5倍
    }

    // 應用倍數，1.5倍需要向上取整，並賦值給displayValue
    this.displayValue = multiplier === 1.5 ? Math.ceil(item * multiplier) : Math.floor(item * multiplier);
  }
}
